import React from 'react';
import ApiSearchInput from 'src/products/api-doc/components/ApiSearchInput/index';

const RegularNavBarCenter = ({ isCoreApi }) => {
  return <React.Fragment>{isCoreApi && <ApiSearchInput />}</React.Fragment>;
};
export default RegularNavBarCenter;
